import PackagesPage from './views/PackagesPage.vue';

export default [
  {
    path: '/packages',
    name: 'packages',
    component: PackagesPage,
    meta: {
      title: 'Mes Colis',
      headerVisible: true,
      headerColor: 'ffffff',
      requiresAuth: true 
    }
  },
  {
    path: '/pay/package/:trackingCode',
    name: 'package-payment-public',
    component: () => import('./views/PackagePaymentPage.vue'),
    meta: {
      title: 'Paiement de colis',
      requiresAuth: false,
      headerVisible: false
    }
  }
];
